/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAddressBook} from '@fortawesome/pro-duotone-svg-icons';

const ContactInformationIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faAddressBook} {...props} />
);

export default ContactInformationIcon;
